import { useState, useEffect } from "react";

export default function TableOfContents({ sections }) {
  const [activeIndex, setActiveIndex] = useState(-1);

  useEffect(() => {
    const headings = sections
      .map((_, i) => document.getElementById(`section-${i}`))
      .filter(Boolean);

    if (headings.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const idx = headings.indexOf(entry.target);
            if (idx !== -1) setActiveIndex(idx);
          }
        }
      },
      { rootMargin: "-80px 0px -60% 0px", threshold: 0 }
    );

    headings.forEach((h) => observer.observe(h));
    return () => observer.disconnect();
  }, [sections]);

  const scrollTo = (index) => {
    const el = document.getElementById(`section-${index}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  if (sections.length === 0) return null;

  return (
    <nav className="hidden xl:block sticky top-28 w-56 shrink-0">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-3">
        On this page
      </p>
      <ul className="space-y-1 border-l border-white/10">
        {sections.map((section, i) => (
          <li key={i}>
            <button
              onClick={() => scrollTo(i)}
              className={`w-full text-left pl-4 pr-2 py-1.5 text-xs leading-snug transition-all border-l -ml-px ${
                activeIndex === i
                  ? "border-cyber-blue text-cyber-blue font-medium"
                  : "border-transparent text-gray-500 hover:text-gray-300 hover:border-white/20"
              }`}
            >
              {section.heading}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
